import React from 'react'
import MoonIcon from '../../assets/images/icons/moon-icon.js'
import SunIcon from '../../assets/images/icons/sun-icon.js'
import PropTypes from 'prop-types';

import { useTheme } from './context/ThemeContext';

function ColorThemeButton({ buttonTheme }) {
    const { theme, toggleTheme } = useTheme();

    const isActive = theme === buttonTheme;

    return (
        <button
            onClick={toggleTheme}
            className={`color-theme-button color-theme-button--${buttonTheme}${isActive ? '--active' : ''}`}
            id={`theme-button-${buttonTheme}`}>
            {buttonTheme == 'light' && <SunIcon />}
            {buttonTheme == 'dark' && <MoonIcon />}
      </button>
    );
}

ColorThemeButton.prototype = {
    buttonTheme: PropTypes.oneOf(['light', 'dark']).isRequired,
};

export default ColorThemeButton